import { h } from 'preact'

export const JeuxVideo = ({ title, URL, images, alt, analytics, cacheKey }) => {
   return (
      <div data-testid="bande-jeux-video" data-cache-key={cacheKey}>
         <div class="container-fluid pt-2">
            <div class="row">
               <div class="col-12">
                  <h2>{title}</h2>
               </div>
            </div>
         </div>
         <div class="row no-gutters">
            <div class="col-12">
               <harmony-banner
                  alt={alt}
                  images={JSON.stringify(images)}
                  url={URL}
                  analytics={JSON.stringify(analytics)}
                  format="1440x310-1472x981"
               />
            </div>
         </div>
      </div>
   )
}
